import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'dateRenderer',
})
export class DateRendererPipe implements PipeTransform {
  transform(value?: Date): string {
    return value ? moment(value).format('L LT') : 'N/A';
  }
}
